import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UserService } from "src/app/_services/user.service";
import { MustMatch } from '../../_helpers/must-match.validator';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer } from '@angular/platform-browser';
import { beatBlipSubscriptionConsts } from 'src/app/consts/beatBlipSubscriptionConsts';
import { ConfirmPasswordValidator } from "../confirm-password.validator";
import { ActivatedRoute } from '@angular/router';
import { UserMgmtService } from 'src/app/_services/user-mgmt.service';
import { HomeService } from 'src/app/_services/home.service';
import { ProjectService } from 'src/app/_services/project.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  //global variables down below
  headerOptions = {
    showSetting : false,
    showSearch: false,
    heading : 'Profile',
    data: undefined,
  }
  currentUser: any;
  changePasswordForm: UntypedFormGroup;
  isInputTypePassword: boolean = true;
  firstName: string;
  lastName: string;
  companyName: string;
  userRole: boolean;
  userImage: any;
  submitted: boolean;
  tabView: string = 'profile';
  licenceUsage: any;
  userType: any;
  domainCheck:any;
  tokenForm: FormGroup;
  currentToken: any;
  today = new Date().toISOString().split('T')[0];
  isTokenExpired = false;

  @ViewChild('closeTokenForm', null) closeTokenForm: ElementRef;
  @ViewChild('closeCopyTokenForm', null) closeCopyTokenForm: ElementRef;
  @ViewChild('closeDeleteTokenForm', null) closeDeleteTokenForm: ElementRef;
  constructor(
   private readonly userService: UserService,
   private readonly userManagement: UserMgmtService,
   private readonly formBuilder: UntypedFormBuilder,
   private readonly toastrService: ToastrService,
   private readonly sanitizer: DomSanitizer,
   private readonly activatedRoute: ActivatedRoute,
   private readonly homeService: HomeService,
   private readonly projectService: ProjectService
  ) {
    this.domainCheck = beatBlipSubscriptionConsts.ADOCheck;
   }

  setHeader(value){
    this.headerOptions.heading = value;
    //set header details
    this.homeService.setHeaderOptions(this.headerOptions);
   if(value=='Licence Usage'){
    this.loadUsers();
   }
  }

  getLicenceUser() {
    var userDetails = JSON.parse(localStorage.getItem('currentUser'))
      var userDomain = userDetails.email.substring(userDetails.email.indexOf('@')+1,userDetails.email.lastIndexOf('.'));
      console.log(userDomain);
      
    this.userService.getLicenceUser(userDomain).subscribe(
      (data)=>{
        this.licenceUsage = data;
        console.log(this.licenceUsage);
        
      }
    )
  }
  loadUsers() {
    this.userManagement.loadUserData().subscribe((response) => {
      if(response){
        this.getLicenceUser()
      }  
   
    })
  }
  ngOnInit() {
    this.initAllForms();
    this.homeService.setHeaderOptions(this.headerOptions);
    this.activatedRoute.fragment.subscribe((res)=>
    {
      this.tabView = res;
      switch(res)
      {
        case 'profile':
          this.setHeader('Profile');
          return;
        case 'viewSetting':
          this.setHeader('View Setting');
          return;
        case 'LicenceUsage':
          this.setHeader('Licence Usage');
          return;
        default:
        return;
      }
    })
    this.loadUser();
    
  }

  initAllForms()
  {
    this.changePasswordForm = this.formBuilder.group(
      {
        password: ["", [Validators.required, Validators.minLength(6)]],
        newPassword: ["", [Validators.required, Validators.minLength(6)]],
        confirmPassword: ["", [Validators.required, Validators.minLength(6)]],
      },
      {
        validators: ConfirmPasswordValidator("newPassword", "confirmPassword"),
      }
    );

    this.tokenForm = this.formBuilder.group(
      {
        date: ["", [Validators.required]],
      
      },
   
    );
  }

  loadUser()
  {
    this.userService.getUser().subscribe((res)=>{
      localStorage.setItem('currentUser', JSON.stringify(res));
      this.currentUser = res;
      this.companyName = res['companyAccount'][0].companyName;

      const tokenExpiryStr = res["tokenExpiryTime"];
      const tokenExpiryTime = Number(tokenExpiryStr); // Convert string to number
      // const tokenExpiryTime = 1751546469011;
      const currentTime = Date.now();
      this.isTokenExpired = tokenExpiryTime < currentTime; // true if token is expired

      this.userService.getUserById(this.currentUser.id).subscribe((res)=>
      {
        this.firstName =  res['firstName'];
        this.lastName = res['lastName'];
        this.userService.getUserType(this.currentUser.userRoleId).subscribe((res: any)=>
    {
         this.userType = res["roleName"];
         
      this.userRole = res.CustomerProfile.privilegeMap.entry[0].value.viewPrivilege.value == 'YES' ? true : false;
      if(this.userRole && this.tabView == 'LicenceUsage'){
        this.loadUsers()
       }
    })
      })
      this.getUserImageById();
    })

  }

  onSubmit() {
    this.submitted = true;
    if (this.changePasswordForm.invalid) {
      return;
    }
    const result = this.userService.changePassword(
      this.changePasswordForm.value
    );
    this.changePasswordForm.reset();
  }

 getExpiryDate(){
  this.submitted = true;
  if (this.tokenForm.invalid) {
    return;
  }
  
  const dateValue = this.tokenForm.value.date;
  const selectedDate = new Date(dateValue);
  
  // Check if selected date is today
  const today = new Date();
  const isToday = selectedDate.toDateString() === today.toDateString();
  
  let dateInMillis;
  
  if (isToday) {
    // If today is selected, set time to end of day (23:59:59.999)
    selectedDate.setHours(23, 59, 59, 999);
    dateInMillis = selectedDate.getTime();
    console.log('Today selected - expiry set to midnight:', new Date(dateInMillis));
  } else {
    // For future dates, keep the default time (start of day)
    dateInMillis = selectedDate.getTime();
    console.log('Future date selected:', new Date(dateInMillis));
  }
  
  console.log('Date in milliseconds:', dateInMillis);
  
  var tokenObj = {
    email: this.currentUser.email,
    tokenCreatedDate: new Date().getTime(),
    tokenName: "CLI_Access_Token"
  }
  
  this.userService.generateToken(dateInMillis, tokenObj).subscribe(
    (res: any) => {
      this.currentToken = res;
      this.currentUser.loginToken = res;
      this.toastrService.clear();
      this.toastrService.success('Access token generated successfully');
      this.loadUser();
      this.closeTokenForm.nativeElement.click();

      this.updateCurrentUserConsoleDate();
    }
  );
}
  
  updateImage(event)
  {
    let reader = new FileReader(); // HTML5 FileReader API
    let file = event.target.files[0];
    if (event.target.files && event.target.files[0]) {
      this.userService.updateImage(file, this.currentUser.id).subscribe((res)=>
      {
        this.toastrService.clear();
        this.toastrService.success('Image updated sucessfully');
        this.getUserImageById();
      })
    }
  }

  getUserImageById()
  {
    this.userService.getUserProfileById(this.currentUser.id).subscribe((res : any)=>
    {
      this.userImage = res.length > 1 ? this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${res}`) : undefined;
    })
  }

  showHideIcon()
  {
    if(this.changePasswordForm.value.password.length == 0 )
    {
      this.isInputTypePassword = true;
    }
  }

  deleteImage()
  {
    this.userService.deleteImage(this.currentUser.id).subscribe((res)=>
    {
      this.toastrService.clear();
      this.toastrService.success("Image deleted successfully");
      this.getUserImageById();
    })
  }

  changeDefaultView(event)
  {
    this.userManagement.updateDefaultView(event.target.checked).subscribe((res)=>
    {
      this.toastrService.clear();
      this.toastrService.success("Default view updated successfully");
      this.loadUser();
    })
  }
 copyRow(row: any): void {
    // const rowString = `Name: ${row.name}, Email: ${row.email}`;
    navigator.clipboard.writeText(row).then(() => {
      this.toastrService.clear();
      this.toastrService.success('Copied to clipboard');
      console.log('Copied to clipboard:', row);
    }).catch(err => {
      console.error('Failed to copy!', err);
    });
  }

  closeCopyToken() {
    this.closeCopyTokenForm.nativeElement.click();
    this.toastrService.clear();
    this.toastrService.success('Login token copied successfully!');
    this.loadUser();
  }

  deleteToken() {
    this.userService.deleteToken(this.currentUser.email).subscribe(
    (res: any) => {
      // this.currentToken = res;
      this.closeDeleteTokenForm.nativeElement.click();
      this.toastrService.clear();
      this.toastrService.success('Login token deleted successfully');
      this.loadUser();
    }, error=>{
      console.log("Error in deleteToken: " + error);
      this.closeDeleteTokenForm.nativeElement.click();
      this.toastrService.clear();
      this.toastrService.success('Login token deleted successfully');
      this.loadUser();
    }
  );
  }

  updateCurrentUserConsoleDate() {
    if(this.currentUser && this.currentUser["email"]) {
      this.projectService.updateConsoleDataByEmail(this.currentUser["email"], this.currentUser["loginToken"]).subscribe((response) => {
        console.log("Response in updateConsoleDataByEmail: "+response);
      }, (error) => {
        console.log("Error in updateConsoleDataByEmail: "+error);
      })
    }
  }
}
